import { GasType } from '../GasType'
import { GhgEmissionCalculationMaterial, GhgEmissionFuelCalculationMaterial } from '../GhgEmissionCalculationMaterial'
import { FuelTransportType } from '../TransportType'

// Referring to government organization (経済産業省、国土交通省) in japan
// https://www.mlit.go.jp/common/001037031.pdf
// fuel consumption (kilo litter)
//  × unit calorific value (Giga joule / kilo litter)
//  × gas emission coefficient (ton-Gas weight / Giga joule)
//  => gas emissions weight(ton)
// 燃料使用量(kl) × 単位発熱量(Gj / kl) × ガス排出量係数(t / Gj)
//  => ガス排出量(t)
export const calcFuelEmission = (fuelConsumption: number, unitCalorificValue: number, gasEmissionCoefficient: number) =>
  fuelConsumption * unitCalorificValue * gasEmissionCoefficient

// https://www.mlit.go.jp/common/001037031.pdf Page.4
// https://elaws.e-gov.go.jp/document?lawid=411CO0000000143_20230401_505CO0000000068
const unitCalorificValueMap: Map<FuelTransportType, number> = new Map([
  ['gasoline', 34.6],
  ['light-oil', 37.7],
  ['heavy-oil-a', 39.1],
  ['heavy-oil-b-c', 41.9],
  ['liquefied-petroleum-gas', 50.8],
  ['jet-fuel-oil', 36.7],
  ['city-gas', 44.8],
])

// https://www.mlit.go.jp/common/001037031.pdf Page.4
// https://elaws.e-gov.go.jp/document?lawid=411CO0000000143_20230401_505CO0000000068
const carbonEmissionCoeffMap: Map<FuelTransportType, number> = new Map([
  ['gasoline', 0.0183],
  ['light-oil', 0.0187],
  ['heavy-oil-a', 0.0189],
  ['heavy-oil-b-c', 0.0195],
  ['liquefied-petroleum-gas', 0.0161],
  ['jet-fuel-oil', 0.0183],
  ['city-gas', 0.0136],
])

function convertToCalcMaterial(material: unknown) {
  const {
    transportType,
    calculationType,
    gasTypes,
    fuelConsumption: fuelConsume,
  } = material as GhgEmissionFuelCalculationMaterial
  return {
    calculationType,
    transportType,
    gasTypes,
    fuelConsumption: fuelConsume,
  } as GhgEmissionFuelCalculationMaterial
}

export function calcFuelCo2Emission(material: GhgEmissionCalculationMaterial) {
  const calcMaterial = convertToCalcMaterial(material)
  const transportType = calcMaterial.transportType as FuelTransportType
  const unitCalorificValue = unitCalorificValueMap.get(transportType) ?? 0
  // CO_2 molecular weight (44) / Carbon molecular weight (12)
  const co2EmissionCoefficient = (carbonEmissionCoeffMap.get(transportType) ?? 0) * (44 / 12)
  return calcFuelEmission(calcMaterial.fuelConsumption, unitCalorificValue, co2EmissionCoefficient)
}

export function getFuelEmissionMap(material: GhgEmissionCalculationMaterial) {
  const coefficientMap = new Map<GasType, number>()
  material.gasTypes.forEach((gasType) => {
    switch (gasType) {
      case 'CO_2':
        coefficientMap.set(gasType, calcFuelCo2Emission(material))
        break
      case 'CH_4':
      case 'N_2O':
      default:
        coefficientMap.set(gasType, 0) // not supported yet
    }
  })
  return coefficientMap
}
